import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'


import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';

import axios from 'axios'
Vue.prototype.$axios = axios

import dotenv from 'dotenv'
dotenv.config()

import { VueJsonp } from 'vue-jsonp'
Vue.use(VueJsonp)

Vue.use(ElementUI);

// 图片上传组件
import ImageUpload from "@/components/ImageUpload"
Vue.component("ImageUpload", ImageUpload);

import tinymce from "vue-tinymce-editor";
import "../public/tinymce/zh_CN";
Vue.component("tinymce", tinymce);

Vue.config.productionTip = false


new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
